import { SearchItemModel } from '../services/base-event-service';
import { FILTER_OPERATOR } from '../services/client-side-search.service';
import {
  CLAUSES_SEARCH_CRITERION,
  ClausesSearchCriterionsFactory,
} from '../factories/clauses-search-criterions.factory';
import {
  BatchUpdateClauseDto,
  GetClauseDto,
  ClausesSearchModel,
} from 'src/app/modules/clauses/models/clauses.model';
import { BulkEditValueModel } from 'src/app/shared/components/bulk-edit/app-bulk-edit-single-value-property/app-bulk-edit-single-value-property.component';

function getClausesFilterConditionsFromModel(
  model: ClausesSearchModel,
  clausesSearchCriterionsFactory: ClausesSearchCriterionsFactory,
): SearchItemModel[] {
  let conditions: SearchItemModel[] = [];

  if (!!model.clauseName) {
    const criterion = clausesSearchCriterionsFactory.getById(CLAUSES_SEARCH_CRITERION.NAME);
    const item = {
      criterion: criterion.id,
      operator: FILTER_OPERATOR.Contains,
      type: criterion.type,
      searchValue: model.clauseName,
      controlName: criterion.controlName,
    } as SearchItemModel;

    conditions.push(item);
  }

  if (!!model.documentType) {
    const criterion = clausesSearchCriterionsFactory.getById(CLAUSES_SEARCH_CRITERION.TYPE);
    const item = {
      criterion: criterion.id,
      operator: FILTER_OPERATOR.ContainsFromArray,
      type: criterion.type,
      searchValue: model.documentType.join(','),
      controlName: criterion.controlName,
    } as SearchItemModel;

    conditions.push(item);
  }

  if (!!model.playbook?.length) {
    const criterion = clausesSearchCriterionsFactory.getById(CLAUSES_SEARCH_CRITERION.PLAYBOOK);
    const item = {
      criterion: criterion.id,
      operator: FILTER_OPERATOR.ContainsFromArray,
      type: criterion.type,
      searchValue: model.playbook.join(','),
      controlName: criterion.controlName,
    } as SearchItemModel;

    conditions.push(item);
  }

  if (!!model.position) {
    const criterion = clausesSearchCriterionsFactory.getById(CLAUSES_SEARCH_CRITERION.POSITION);
    const item = {
      criterion: criterion.id,
      operator: FILTER_OPERATOR.ContainsFromArray,
      type: criterion.type,
      searchValue: model.position.join(','),
      controlName: criterion.controlName,
    } as SearchItemModel;

    conditions.push(item);
  }

  if (!!model.languageId) {
    const criterion = clausesSearchCriterionsFactory.getById(CLAUSES_SEARCH_CRITERION.LANGUAGE);
    const item = {
      criterion: criterion.id,
      operator: FILTER_OPERATOR.ContainsFromArray,
      type: criterion.type,
      searchValue: model.languageId.join(','),
      controlName: criterion.controlName,
    } as SearchItemModel;

    conditions.push(item);
  }

  return conditions;
}

function getUpdatedClausesByBulkEditOperation(
  allClauses: GetClauseDto[],
  model: BulkEditValueModel,
): BatchUpdateClauseDto[] {
  let clausesWithUpdates: BatchUpdateClauseDto[] = [];

  allClauses
    .filter((item) => model.selectedMainItemsIds.includes((item as any)[model.mainItemIdKey] + ''))
    .forEach((item) => {
      const clauseModel = {
        id: item.uniqueId,
        documentTypes: item.documentTypes,
        positions: item.positions,
        languageId: item.languageId,
      } as BatchUpdateClauseDto;

      (clauseModel as any)[model.fieldToBeModifiedName] = model.checkedOptionValue;
      clausesWithUpdates.push(clauseModel);
    });

  return clausesWithUpdates;
}

export { getClausesFilterConditionsFromModel, getUpdatedClausesByBulkEditOperation };
